import { Fragment, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";

import BackButton from "../BackButton.jsx";
import Button from "../Button.jsx";
import Checkbox from "../Checkbox.jsx";
import TextField from "../TextField.jsx";

import i18n from "../../i18n.js";
import { selectCurrentUser, setLoading, setUser } from "../../store";
import registrationApi from "../../api/registration";
import { renderHtml } from "../../helpers.js";
import AutoSuggest from "../AutoSuggest.jsx";

export default function RegistrationSignUp({
  genderOptions,
  goTo,
  headContent,
  onBack,
  onNext,
  error,
  setError,
  email,
  setEmail,
  showInviteCode,
}) {
  const [gender, setGender] = useState("");
  const [password, setPassword] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [name, setName] = useState("");
  const [marketing, setMarketing] = useState(false);
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);

  useEffect(() => {
    setName(currentUser.name);
  }, []);

  async function handleSubmit(event) {
    event.preventDefault();
    setError(null);

    try {
      dispatch(setLoading(true));
      const genderOption = genderOptions.find(({ key }) => key == gender);
      const { user } = await registrationApi.register(
        name,
        email,
        genderOption ? genderOption.value : "",
        password,
        inviteCode
      );
      dispatch(setUser(user));
      onNext();
    } catch (err) {
      setError(err);
    }
    dispatch(setLoading(false));
  }

  return (
    <Fragment>
      {headContent}

      <TextField
        name="name"
        label={i18n.t("component.task_modules.registration.labels.name")}
        error={error && error.errors && error.errors.name}
        type="text"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
      <AutoSuggest
        suggestions={genderOptions
          .filter(({ value }) => value)
          .map(({ key, value }) => ({
            text: key,
            value,
          }))}
        value={gender}
        onChange={setGender}
        inputProps={{
          error: error && error.errors && error.errors.gender,
          id: "gender",
          name: "gender",
          label: i18n.t("component.task_modules.registration.labels.gender"),
          class: "autocomplete",
          value: gender,
          autocomplete: "off",
          expandable: true,
        }}
      />

      <TextField
        name="email"
        label={i18n.t("component.task_modules.registration.labels.email")}
        error={error && error.errors && error.errors.email}
        type="text"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
      />
      <TextField
        name="password"
        label={i18n.t("component.task_modules.registration.labels.password")}
        error={error && error.errors && error.errors.password}
        type="password"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        revealable
      />
      {showInviteCode && (
        <TextField
          name="inviteCode"
          label={i18n.t(
            "component.task_modules.registration.labels.invite_code"
          )}
          error={error && error.errors && error.errors.inviteCode}
          info={i18n.t("component.task_modules.registration.invite_code_info")}
          type="text"
          value={inviteCode}
          onChange={(event) => setInviteCode(event.target.value)}
        />
      )}

      <p class="t-body4 color-shades-charcoal mt-32">
        {renderHtml(i18n.t("component.task_modules.registration.terms_note"))}
      </p>
      <Checkbox
        onChange={(event) => {
          setMarketing(event.target.checked);
        }}
        {...(marketing ? { checked: "checked" } : {})}
        leftAligned={true}
        multilinable={true}
        class="mt-32"
      >
        {i18n.t("component.task_modules.registration.labels.marketing")}
      </Checkbox>

      <p class="mt-48">
        <BackButton noIndent onClick={onBack} />
        <Button onClick={handleSubmit}>
          {i18n.t("component.task_modules.registration.submit_button.sign_up")}
        </Button>
      </p>

      <p class="t-body4 mt-48">
        {i18n.t("component.task_modules.registration.already_account")}{" "}
        <a
          href="#"
          onClick={(event) => {
            event.preventDefault();
            goTo("logIn");
          }}
        >
          {i18n.t("component.task_modules.registration.log_in")}
        </a>
      </p>
    </Fragment>
  );
}
